import React, {forwardRef, useImperativeHandle, useState} from "react";
import {message, Modal, Upload} from "antd";
import {IconClose} from "../../Icon";
import Dragger from "antd/es/upload/Dragger";
import {
    generateRandomMixedIdNoNumber,
    generateShortUUID,
    generateUUID2,
    getFileName,
    getFileNameWithoutExt, hasDesktopBaseLicense,
    hasLicense,
    imgPathPerfix
} from "../../utils";
import {ipcInvoke, ipcSend} from "../../common/ipc";
import {t} from "i18next";
import {postMessage} from "@/common/event";
import {EVENT_SHOW_PROGRESS, MAX_SIZE} from "@/Const";
import {updateFontInfo} from "@model/fontInfo";
import {FONT_FAMILY} from "../../../@excalidraw/packages/excalidraw";
import {isZh} from "@/language";

const DialogFontChoose = forwardRef((props, ref)=>{
    useImperativeHandle(ref,()=>({
        onShowDialog:onShowDialog
    }));
    const [isShowDialog,setIsShowDialog] = useState(false);

    const onShowDialog = ()=>{
        setIsShowDialog(true)
    }

    const uploadProps:{ beforeUpload: (file:any) => string } = {
        beforeUpload:(file)=>{
            if (file.size > MAX_SIZE){
                message.error(t("The maximum file"));
                return Upload.LIST_IGNORE;
            }

            setIsShowDialog(false);
            const id = generateUUID2();
            postMessage(EVENT_SHOW_PROGRESS,{tips:t("Importing"),id:id,fontName:getFileNameWithoutExt(file.name)})
            ipcInvoke('import-font-file',{filePath:file.path}).then(res=>{
                //save to list
                const font = {id,shortName:generateRandomMixedIdNoNumber(8), fontPath:file.name, fontName:getFileNameWithoutExt(file.name),createTime:Date.now()};
                updateFontInfo(font);

                FONT_FAMILY[font.fontName] = font.fontName;
                //创建一个无用的span 强制加载字体....
                var span = document.createElement('span');
                span.style.fontFamily = font.fontName;
                document.body.appendChild(span);
            });

            return Upload.LIST_IGNORE
        }
    }

    return(
        <Modal centered={true} open={isShowDialog} closable={true} closeIcon={<IconClose/>} footer={''}
               onCancel={(e) => setIsShowDialog(false)} width='468px' style={{height: 'auto'}}>
            <div className='font-size-12' style={{
                margin: '-22px',
                display: 'flex',
                padding: '20px',
                flexDirection: 'column'
            }}>
                <span className='dialog-title'>{t("Import custom font")}</span>
                <div className='line' style={{margin: '12px -16px'}}></div>
                <span style={{color: '#666666', marginTop: '1px', lineHeight: '24px'}}>{t("ImportYourCustomFont")}</span>
                <div style={{backgroundColor: '#F5F5F5', height: '216px', width: '100%', borderRadius: '8px',marginTop:'12px'}}>
                    <Dragger disabled={!hasLicense()} {...uploadProps} accept={".ttf,.otf"}
                             style={{outline: 'none', border: '0px'}}>
                        <p className="ant-upload-text">
                            <img style={{width: '120px', height: '120px'}} src={imgPathPerfix() + "font_choose.png"}/>
                        </p>
                        <p className='font-family-semi-bold font-size-14'
                           style={{color: '#AFAFAF'}}>{t("Click here or drag")}</p>
                    </Dragger>
                </div>

                {
                    !hasLicense() && !hasDesktopBaseLicense() &&
                    <div className='flex-center button-solid-style'
                         style={{width: '164px', height: '38px', marginTop: '20px',alignSelf:'center'}} onClick={() => {
                        if (!hasLicense() && !hasDesktopBaseLicense()) {
                            if (isZh()) {
                                ipcSend('open-url',import.meta.env.VITE_HTTP_PURCHASE_PRICE_ZH)
                            }else {
                                ipcSend('open-url', import.meta.env.VITE_HTTP_PURCHASE_PRICE);
                            }
                        }
                    }}>
                        <img className='img-18' src={imgPathPerfix() + 'vip_white.png'}/>
                        <span className='ml-6 font-family-medium'>{t("Try PRO")}</span>
                    </div>
                }

            </div>
        </Modal>
    )
})

export default DialogFontChoose;